import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {ReportAccountComponentModel} from '../../../api/entity/reportAccountComponent.model';
import {ReportAccountComponentConverter} from '../../../api/entity/converter/reportAccountComponent.converter';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable()
export class ReportAccountComponentDataService extends AbstractDataServiceV2<ReportAccountComponentModel, ReportAccountComponentConverter> {
    constructor(http: HttpClient,
                httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: ReportAccountComponentConverter) {
        super('ReportAccountComponent', http, httpUrlGenerator, logger, config, converter);
    }
}
